<div class="modal-header">
    <h4 class="modal-title">Add New Merchant Access Users</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="addMerchantAccessUsersForm" novalidate>
        <div class="mb-3 row">
            <label for="merchantProfile" class="col-3 col-form-label text-end">Merchant Profile</label>
            <div class="col">
                <select class="form-select" id="merchantProfile" formControlName="merchantProfileId" [ngClass]="{ 'is-invalid': merchantProfileId.errors && showErrors }">
                    <option *ngFor="let merchantProfile of merchantProfiles" [ngValue]="merchantProfile.id">{{merchantProfile.name}}</option>
                </select>
                <div *ngIf="merchantProfileId.invalid && showErrors" class="text-danger">
                    <small *ngIf="merchantProfileId.errors.required">Merchant Profile is required</small>
                </div>
            </div>
        </div>
        <ng-container formArrayName="accessUsers">
            <div class="mb-3 row" *ngFor="let accessUser of accessUsers.controls; index as i; let first = first;">
                <label for="accessUser" class="col-sm-3 col-form-label text-end" *ngIf="first">Merchant Access User</label>
                <div class="col-sm-3 text-end" *ngIf="!first">
                    <button type="button" class="btn btn-outline-danger" (click)="onDeleteAccessUser(i)" *ngIf="!accessUser.value" title="Remove Merchant Access User">
                        <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    </button>
                </div>
                <div class="col">
                    <university-person id="accessUser"
                                       [formControlName]="i"
                                       [canDelete]="true"
                                       (onDeletePerson)="onDeleteAccessUser(i)"
                                       [canEdit]="true"
                                       [isInvalid]="accessUser.errors && showErrors"></university-person>
                    <div *ngIf="accessUser.invalid && accessUser.errors.required && showErrors" class="text-danger">
                        <small>Merchant Access User is required</small>
                    </div>
                    <div *ngIf="accessUser.invalid && (accessUser.errors.isActive || accessUser.errors.unique)" class="text-danger">
                        <small *ngIf="accessUser.errors.isActive">Merchant Access User must be an active employee</small>
                        <small *ngIf="accessUser.errors.unique">Merchant Access User must be unique</small>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="mb-3 row" *ngIf="showAddAccessUser()">
            <div class="col offset-3">
                <button type="button" class="btn btn-success" (click)="onAddAccessUser()" title="Add Another Merchant Access User">
                    <fa-icon [icon]="['fas', 'user-plus']"></fa-icon> Add Another Merchant Access User
                </button>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="onSave()" [disabled]="saving">
        <i class="fa fa-save"></i> Save <action-spinner *ngIf="saving"></action-spinner>
    </button>
</div>
